var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1731_549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5859 10.0833H6.41927C5.40675 10.0833 4.58594 10.9042 4.58594 11.9167V17.4167C4.58594 18.4292 5.40675 19.25 6.41927 19.25H15.5859C16.5985 19.25 17.4193 18.4292 17.4193 17.4167V11.9167C17.4193 10.9042 16.5985 10.0833 15.5859 10.0833Z",
    stroke: "#B1BAD1",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0026 15.5833C11.5089 15.5833 11.9193 15.1729 11.9193 14.6667C11.9193 14.1604 11.5089 13.75 11.0026 13.75C10.4963 13.75 10.0859 14.1604 10.0859 14.6667C10.0859 15.1729 10.4963 15.5833 11.0026 15.5833Z",
    stroke: "#B1BAD1",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33594 10.0833V6.41667C7.33594 5.44421 7.72225 4.51158 8.40988 3.82394C9.09751 3.13631 10.0301 2.75 11.0026 2.75C11.9751 2.75 12.9077 3.13631 13.5953 3.82394C14.283 4.51158 14.6693 5.44421 14.6693 6.41667V10.0833",
    stroke: "#B1BAD1",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1731_549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7d6f4ba90f83bb31b1b5d1911a8393d7.svg";
export { ForwardRef as ReactComponent };